import { checkFormValidity } from './checkFormValidity';
import { getCheckoutUpsellElement } from './getCheckoutUpsellElements';

export const getCheckoutFormValidity = () => {
  const {
    customerInfoForm,
    additionalCustomerInfoForm,
    billingAddressForm,
    shippingAddressForm,
  } = getCheckoutUpsellElement();

  const checkoutForms = [
    customerInfoForm,
    additionalCustomerInfoForm,
    billingAddressForm,
    shippingAddressForm,
  ];

  const { checkoutFormValidity } = checkFormValidity(checkoutForms);

  return { checkoutFormValidity };
};
